import { SyntheticEvent, useEffect, useState } from 'react';

import { TokenInfo } from 'types';

import * as S from './TokenLogo.styles';

type Props = {
  token?: TokenInfo | null;
  size?: number;
  symbol?: string;
  logoUrl?: string;
};

export const TokenLogo = (props: Props) => {
  const { token, size = 24, symbol, logoUrl } = props;
  const [error, setError] = useState<SyntheticEvent<HTMLImageElement, Event> | null>(null);

  let src: string | null = null;

  // Priority: logoUrl prop > token hasLogo > token logoURI
  if (logoUrl) {
    src = logoUrl;
  } else if (token?.tags?.includes('hasLogo')) {
    src = `https://raw.githubusercontent.com/wowswap-io/wowmax-tokens/refs/heads/main/${
      token.chainId
    }/${token.logoSymbol || token.symbol}_${token.address.toLowerCase()}.png`;
  } else if (token?.logoURI) {
    src = token.logoURI;
  }

  useEffect(() => {
    setError(null);
  }, [token, logoUrl]);

  return (
    <S.Root>
      {!src || error ? (
        <S.Mock $size={size}>{(token?.symbol || symbol || '?').slice(0, 1)}</S.Mock>
      ) : (
        <img
          src={src}
          alt={token?.symbol || symbol || 'Token icon'}
          height={size}
          width={size}
          loading="lazy"
          onError={(err) => setError(err)}
        />
      )}
    </S.Root>
  );
};
